import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MyImage from "../images/hh.webp";
import "./AllTypePayments.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../images/mobile recharge.webp";
import Logo1 from "../images/electricity_bill.webp";
import Logo2 from "../images/fast.webp";
import Logo3 from "../images/dish.webp";
import Logo4 from "../images/credit_card.webp";
import Logo5 from "../images/piped gas.webp";
import Logo6 from "../images/cable_tv.webp";
import Logo7 from "../images/broadband.webp";
import Logo8 from "../images/gas_cylinder.webp";
import Logo9 from "../images/water_bill.webp";

import EbillIcon from "../images/icon_3.webp";
import EbillIcon1 from "../images/icon_2.webp";
import EbillIcon2 from "../images/icon_1.webp";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Explore from "./Explore";

const cards = [
  {
    title: "Mobile Recharge",
    logo: Logo,
    bgColor: "#FFE9DF",
    link: "/mobileprepaid",
  },
  {
    title: "Electricity",
    logo: Logo1,
    bgColor: "#FFF3DF",
    link: "/electricity",
  },
  { title: "Fastag", logo: Logo2, bgColor: "#EEFFDF", link: "/fastag" },
  { title: "DTH", logo: Logo3, bgColor: "#DFEBFF", link: "/dth" },
  {
    title: "Credit Card",
    logo: Logo4,
    bgColor: "#E6DFFF",
    link: "/credit-card",
  },

  { title: "Pipe Line Gas", logo: Logo5, bgColor: "#FFE9DF", link: "/pipe" },
  {
    title: "Cable Rechage",
    logo: Logo6,
    bgColor: "#FFF3DF",
    link: "/cablewire",
  },
  { title: "Broadband", logo: Logo7, bgColor: "#EEFFDF", link: "/broadband" },
  { title: "Gas Cylinder", logo: Logo8, bgColor: "#DFEBFF", link: "/gas" },
  { title: "Water Bill", logo: Logo9, bgColor: "#E6DFFF", link: "/water" },
];

const AllTypePayment = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [cycleCount, setCycleCount] = useState(0); // Track autoplay cycle
  const intervalRef = useRef(null);
  const leaveTimeout = useRef(null);
  const location = useLocation(); // Get current location/route

  // Start autoplay on mount
  useEffect(() => {
    startAutoplay();
    return () => clearInterval(intervalRef.current);
  }, []);

    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const startAutoplay = () => {
    clearInterval(intervalRef.current); // Avoid multiple intervals
    intervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % cards.length;

        if (newIndex === 0) {
          // Completed one full cycle
          setCycleCount((prev) => prev + 1);
          setHoveredIndex(null); // Remove hover effect
          setIsHovering(false); // Reset hover state
        }

        return newIndex;
      });
    }, 3000); // Change interval as needed
  };

  const handleMouseEnter = (index) => {
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }
    leaveTimeout.current = setTimeout(() => {
      // Optional logic after 1s
    }, 1000);
    setHoveredIndex(index);
    setActiveIndex(index);
    setIsHovering(true);
    clearInterval(intervalRef.current); // Pause autoplay
  };

  const handleMouseLeave = () => {
    leaveTimeout.current = setTimeout(() => {
      setHoveredIndex(null);
      setIsHovering(false);
      startAutoplay(); // Resume autoplay
    }, 1000);
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
    startAutoplay();
  };

  // Function to check if a card represents the current page
  const isCurrentPageCard = (cardLink) => {
    return location.pathname === cardLink;
  };

  // Handle card click
  const handleCardClick = (link, e) => {
    e.preventDefault();
    window.location.href = link;
  };

  return (
    <>
      <Navbar />
      <div className="main-box-box-2">
        <div className="row">
          <div className=" col-12 col-md-12">
            <section className="Loan-type-center">
              <div className="container">
                <div className="row justify-content-center align-items-center text-center ">
                  <div className="col-12">
                    <div className="main-18">
                      <div className="row align-items-center">
                        <div className="col-12 col-md-6 text-center text-md-start mb-4 mb-md-0  px-md-4">
                          <h1 className="fw-semibold fs-md-2 fs-lg-1   loan-text-22">
                            Pay Smart,
                            <br className="d-none d-md-block  d-sm-block" />
                            Pay Easy,
                            <br className="d-none d-md-block  d-sm-block" />
                            Pay Instantly
                          </h1>
                        </div>

                        <div className="col-12 col-md-6 ">
                          <div className="position-relative overflow-hidden d-flex justify-content-center align-items-center">
                            <div className="about-class-box-9 position-absolute"></div>

                            <div className="circle-card card-1 position-absolute">
                              <div className="card-content d-flex align-items-center gap-2">
                                <img
                                  src={EbillIcon2}
                                  alt="Electricity Icon"
                                  style={{
                                    width: "22px",
                                    height: "auto",
                                    maxHeight: "70px",
                                    objectFit: "contain",
                                  }}
                                />
                                <span className="text-nowrap  small text-md-body1 text-sm-body1">
                                  Electricity Bill
                                </span>
                              </div>
                            </div>

                            <div className="circle-card card-2 position-absolute">
                              <div className="card-content d-flex align-items-center gap-2">
                                <img
                                  src={EbillIcon1}
                                  alt="Mobile Icon"
                                  style={{
                                    width: "22px",
                                    height: "auto",
                                    maxHeight: "70px",
                                    objectFit: "contain",
                                  }}
                                />
                                <span className="text-nowrap  small text-md-body1 text-sm-body1">
                                  Mobile Recharge
                                </span>
                              </div>
                            </div>

                            <div className="circle-card card-3 position-absolute">
                              <div className="card-content d-flex align-items-center gap-2 flex-wrap">
                                <img
                                  src={EbillIcon}
                                  alt="DTH Icon"
                                  className="img-fluid"
                                  style={{
                                    width: "22px",
                                    height: "auto",
                                    maxHeight: "70px",
                                    objectFit: "contain",
                                  }}
                                />
                                <span className="text-nowrap small text-md-body1 text-sm-body1">
                                  DTH Recharge
                                </span>
                              </div>
                            </div>

                            <div
                              className="position-relative"
                              style={{ zIndex: 1 }}
                            >
                              <img
                                src={MyImage}
                                alt="Hero Illustration"
                                className="img-fluid image-class-9"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="Exploreproduct">
              <div className="container px-2 py-5">
                <h2 className="text-center mb-4 fw-semibold">
                  Types of Payments <br className="d-block d-sm-none" />
                  We Offer
                </h2>

                <div className="row  g-5 justify-content-center">
                  {cards.slice(0, 5).map((card, index) => {
                    const isActive = activeIndex === index;
                    const isHovered = hoveredIndex === index;
                    const isCardActive =
                      isHovered || (isActive && hoveredIndex === null);
                    const currentPageCard = isCurrentPageCard(card.link);
                    return (
                      <div
                        key={`row1-${index}`}
                        className="col-12 col-sm-6 col-md-4 col-lg-2 mb-3 mb-sm-3 mb-md-4 mb-lg-4 d-flex flex-column align-items-center px-2"
                      >
                        <div
                          className={`card-custom  ${
                            isCardActive ? "active-card" : ""
                          }`}
                          style={{
                            backgroundColor: card.bgColor,
                            borderRadius:
                              isCardActive && window.innerWidth > 576
                                ? "50%"
                                : "8px", // No circle on mobile
                            width: window.innerWidth <= 576 ? "240px" : "158px", // 290px only on mobile
                            height:
                              window.innerWidth <= 576 ? "240px" : "158px",
                            transition: "all 0.3s ease-in-out",
                            overflow: isCardActive ? "visible" : "hidden",
                          }}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                          onTouchStart={() => handleMouseEnter(index)}
                          onTouchEnd={handleMouseLeave}
                          onClick={(e) => handleCardClick(card.link, e)}
                        >
                          {/* <div
                            className="card-body-custom"
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <img
                              src={card.logo}
                              alt={card.title}
                              className="logo-img"
                              style={{
                                width: isCardActive ? "170px" : "130px",
                                height: isCardActive ? "170px" : "130px",
                                transition: "all 0.3s ease-in-out",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                                cursor: "pointer",
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                                opacity: currentPageCard ? 0.9 : 1,
                                filter: currentPageCard
                                  ? "brightness(1.1) saturate(1.2)"
                                  : "none",
                              }}
                              draggable={false}
                            />
                          </div> */}
                          <div className="card-body-custom d-flex align-items-center justify-content-center w-100 h-100">
                            <Link
                              to={card.link}
                              className="text-decoration-none"
                              style={{
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                                display: "block",
                                position: "relative",
                                width: "100%",
                                height: "100%",
                              }}
                              onFocus={(e) => e.target.blur()}
                            >
                              <img
                                src={card.logo}
                                alt={card.title}
                                className="logo-img"
                                style={{
                                  width:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  height:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  transition: "all 0.3s ease-in-out",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: isCardActive ? 3 : 2,
                                  pointerEvents: "none",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  opacity: isCurrentPageCard ? 0.9 : 1,
                                  filter: isCurrentPageCard
                                    ? "brightness(1.1) saturate(1.2)"
                                    : "none",
                                }}
                                draggable={false}
                                onFocus={(e) => e.target.blur()}
                              />
                            </Link>
                          </div>
                        </div>

                        <div className="w-100 text-center position-abs py-2">
                          <Link
                            to={card.link}
                            className="text-decoration-none text-dark"
                            style={{
                              color: currentPageCard ? "#007bff" : "#000",
                              fontWeight: currentPageCard ? "600" : "normal",
                            }}
                          >
                            <h6
                              className="mb-0"
                              style={{
                                fontFamily: "poppins",
                                fontSize: "20px",
                              }}
                            >
                              {card.title}
                            </h6>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="row g-5 justify-content-center">
                  {cards.slice(5, 10).map((card, index) => {
                    const actualIndex = index + 5; // Adjust index to match global activeIndex
                    const isActive = activeIndex === actualIndex;
                    const isHovered = hoveredIndex === actualIndex;
                    const isCardActive =
                      isHovered || (isActive && hoveredIndex === null);
                    const currentPageCard = isCurrentPageCard(card.link);
                    return (
                      <div
                        key={`row2-${index}`}
                        className="col-12 col-sm-6 col-md-4 col-lg-2 mb-3 mb-sm-3 mb-md-4 mb-lg-4 d-flex flex-column align-items-center px-2"
                      >
                        <div
                          className={`card-custom  ${
                            isCardActive ? "active-card" : ""
                          }`}
                          style={{
                            backgroundColor: card.bgColor,
                            borderRadius:
                              isCardActive && window.innerWidth > 576
                                ? "50%"
                                : "8px", // No circle on mobile
                            width: window.innerWidth <= 576 ? "240px" : "158px", // 290px only on mobile
                            height:
                              window.innerWidth <= 576 ? "240px" : "158px",
                            transition: "all 0.3s ease-in-out",
                            overflow: isCardActive ? "visible" : "hidden",
                          }}
                          onMouseEnter={() => handleMouseEnter(actualIndex)}
                          onMouseLeave={handleMouseLeave}
                          onTouchStart={() => handleMouseEnter(actualIndex)}
                          onTouchEnd={handleMouseLeave}
                          onClick={(e) => handleCardClick(card.link, e)}
                        >
                          <div className="card-body-custom d-flex align-items-center justify-content-center w-100 h-100">
                            <Link
                              to={card.link}
                              className="text-decoration-none"
                              style={{
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                                display: "block",
                                position: "relative",
                                width: "100%",
                                height: "100%",
                              }}
                              onFocus={(e) => e.target.blur()}
                            >
                              <img
                                src={card.logo}
                                alt={card.title}
                                className="logo-img"
                                style={{
                                  width:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  height:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  transition: "all 0.3s ease-in-out",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: isCardActive ? 3 : 2,
                                  pointerEvents: "none",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  opacity: isCurrentPageCard ? 0.9 : 1,
                                  filter: isCurrentPageCard
                                    ? "brightness(1.1) saturate(1.2)"
                                    : "none",
                                }}
                                draggable={false}
                                onFocus={(e) => e.target.blur()}
                              />
                            </Link>
                          </div>
                        </div>

                        <div className="w-100 text-center position-abs py-2">
                          <Link
                            to={card.link}
                            className="text-decoration-none text-dark"
                            style={{
                              color: currentPageCard ? "#007bff" : "#000",
                              fontWeight: currentPageCard ? "600" : "normal",
                            }}
                          >
                            <h6
                              className="mb-0"
                              style={{
                                fontFamily: "poppins",
                                fontSize: "20px",
                              }}
                            >
                              {card.title}
                            </h6>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Explore />
      <Footer />
    </>
  );
};

export default AllTypePayment;
